import React, { useState } from "react";

import { Collapse, Select, Button } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import CascadeTree from "./CascadeTree";
const { Option } = Select;

function Cascades() {
  return (
    <div className="pb-8">
      {/* <div className="text-base pri-font mb-3">Objective</div> */}
      <div className="mb-3 max-w-3xl flex">
        <div className="w-3/12">
          <Select
            style={{ width: "100%" }}
            defaultValue="group"
            placeholder="Select unit"
          >
            <Option value="group">Hayleys group</Option>
            <Option value="company">Kingsbury</Option>
            <Option value="department">Financial department</Option>
          </Select>
        </div>
        <div className="w-7/12 pl-3">
          <Select
            style={{ width: "100%" }}
            defaultValue="group"
            placeholder="Select objective"
          >
            <Option value="group">
              Revenue target for the financial year - 10 Million LKR
            </Option>
            <Option value="company">
              Acquisition of new customers - 5 Million LKR
            </Option>
            <Option value="department">
              Total collections - 5 Million LKR
            </Option>
          </Select>
        </div>
        <div className="2/12 pl-3">
          <Button type="primary">Load</Button>
        </div>
      </div>
      <CascadeTree />
    </div>
  );
}

export default Cascades;
